export function replaceUrlsFriendly(text: string, prefix: string): string {
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlPattern, (url) => {
    const newUrl = getExampleUrl(prefix);
    return `<a class="link" target="blank" href="${url}">${newUrl}</a>`;
  });
}

export function getBuzzwaveGoUrl(buzzwaveGoUrl: string, forwardUrl: string, campaignId: string, clientAccountId: string, newCampaignShareId: string, testMode = false): string {
  const url = new URL(buzzwaveGoUrl);
  url.searchParams.set('buzzwavecampaignid', campaignId);
  url.searchParams.set('buzzwaveclientaccountid', clientAccountId);
  url.searchParams.set('buzzwavecampaignshareid', newCampaignShareId);
  url.searchParams.set('testMode', String(testMode));
  url.searchParams.set('forwardurl', forwardUrl);
  return url.toString();
}

export function getExampleUrl(prefix: string): string {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return `${prefix}/${result}`;
}

export function legacyCopy(text: string) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback copy failed:', err);
  }
  document.body.removeChild(textarea);
}

export function getErrorHtmlString(errorMessage: string): string {
  return `
  <!DOCTYPE html>
  <html lang="en">
  <head>
    <title>Error</title>
    <style>
      body {
          font-family: Arial, sans-serif;
          background-color: #f2f2f2;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          margin: 0;
      }
  
      .content-container {
          text-align: center;
          background-color: #fff;
          margin: 10px 20px;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }
  
      h1 {
        color: #ff6347;
        font-size: 48px;
        margin-bottom: 20px;
      }
  
      p {
        color: #666;
        font-size: 14px;
        margin-bottom: 30px;
      }
  
      a {
        color: #007bff;
        text-decoration: none;
      }
  
      a:hover {
        text-decoration: underline;
      }
    </style>
  </head>
  <body>
    <div class="content-container">
      <h1>Oops! Something went wrong.</h1>
      <p>${errorMessage}</p>
    </div>
  </body>
  </html>
  `;
}
